/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeaderboardEntryDto } from '../../models/leaderboard-entry-dto';

export interface VolunteerStatsControllerGetLeaderboard$Params {
  limit: number;
}

export function volunteerStatsControllerGetLeaderboard(http: HttpClient, rootUrl: string, params: VolunteerStatsControllerGetLeaderboard$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LeaderboardEntryDto>>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsControllerGetLeaderboard.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LeaderboardEntryDto>>;
    })
  );
}

volunteerStatsControllerGetLeaderboard.PATH = '/volunteer-stats/leaderboard';
